export default __webpack_public_path__ + "static/media/sideimg.9d1e4c69.png";